import { getInitParams, detectMobileBrowser } from 'utils'
import { computeDeviceSize } from 'app/theme'

const { language, originURL } = getInitParams()

const { innerWidth, innerHeight } = window
const deviceSize = computeDeviceSize(innerWidth)

function getPostMessageTargetOrigin(url) {
  if (!url) return undefined
  try {
    const { origin } = new URL(url)

    if (!origin) return undefined
    if (origin === 'file://') return undefined

    return origin
  } catch {
    return undefined
  }
}

const isMobileBrowser = detectMobileBrowser()
export default {
  drawer: {
    active: false,
  },
  modal: {
    active: false,
  },
  snackbar: {
    active: false,
    message: '',
    buttonText: '',
  },
  banners: {
    geolocationAlert: {
      active: false,
    },
  },
  fullscreenButton: {
    visible: true,
  },
  mobile: isMobileBrowser,
  deviceWidth: innerWidth,
  deviceHeight: innerHeight,
  deviceSize,
  language,
  isMobileMenuOpen: false,
  isVerticalScrollEnabled: false,
  originURL,
  postMessageTargetOrigin: getPostMessageTargetOrigin(originURL),
}
